import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import { GET_SIGN_IMAGE_CONTENT } from '../queries/device.queries';
import { Fragment } from 'react';
import './styles/image-content.scss';
import CircularProgress from '@material-ui/core/CircularProgress';

const SignImageContent = ({
    signID, imageID
}) => {

    if(imageID === undefined || imageID === "N/A") {
      return null;
    }

    return (
      <Fragment>
        <Query query={GET_SIGN_IMAGE_CONTENT} variables={{id: signID, name: imageID}} fetchPolicy="cache-first">
          {({ data, error, loading }) => {

              if(error !== undefined) {
                console.log("SignImageContent", error);
                return null;
              }

              if(data === undefined) {
                return <div className="imageLoading"><CircularProgress/></div>;
              }

              if(data !== undefined && data.signImageContent !== null) {
                return (<img src={data.signImageContent.data} alt=""/>);
              }
              return null;
          }}
        </Query>
      </Fragment>
    );
};

SignImageContent.propTypes = {
  imageID: PropTypes.string.isRequired,
  signID: PropTypes.string.isRequired
};

export default SignImageContent;